import { render, staticRenderFns } from "./m-form-address-cn-en.vue?vue&type=template&id=5de6e279&scoped=true&"
import script from "./m-form-address-cn-en.vue?vue&type=script&lang=js&"
export * from "./m-form-address-cn-en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de6e279",
  null
  
)

export default component.exports